<app-single-select-dropdown
	label="Meetellende vestigingen"
	[opties]="isLeerlingen ? leerlingOptions : cijferOptions"
	[selectedOptie]="getSelectedOption()"
	(onOptieClicked)="selectOption($event)"
>
</app-single-select-dropdown>
